import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/request_success.svg'


const _withScopeId = n => (_pushScopeId("data-v-b39e999c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loading_bg"
}
const _hoisted_2 = { class: "loading-spinner" }
const _hoisted_3 = {
  key: 0,
  viewBox: "25 25 50 50",
  class: "circular"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "50",
  cy: "50",
  r: "20",
  fill: "none",
  class: "path"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  src: _imports_0,
  alt: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.msg.isShow)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (!_ctx.msg.isShowSuccess)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_3, _hoisted_5))
            : (_openBlock(), _createElementBlock("img", _hoisted_6)),
          _createElementVNode("span", null, _toDisplayString(_ctx.msg.text), 1)
        ])
      ]))
    : _createCommentVNode("", true)
}